// Color configurations for the entire application
export const brandColors = {
  primary: '#2c58dc',    // primary blue
  secondary: '#3423ba',  // deep blue
  accent: '#6694ec',     // light blue
  light: '#edf3fa',      // lightest blue
  dark: '#3b3dcd'        // medium blue
};

// Discipline colors configuration
export const disciplineColorConfig = {
  'slalom': { color: brandColors.primary },
  'giant slalom': { color: brandColors.secondary },
  'downhill': { color: brandColors.accent },
  'super g': { color: brandColors.dark },
  'parallel': { color: '#4b6cdc' },
  'combined': { color: '#8ba3e8' },
  'team event': { color: '#5470d6' },
};

// Position colors configuration
export const positionConfig = {
  '1': { color: '#FFD700', label: 'Gold' },
  '2': { color: '#C0C0C0', label: 'Silver' },
  '3': { color: '#CD7F32', label: 'Bronze' },
  '4': { color: '#DEB887', label: '4th' },
  '5': { color: '#F5DEB3', label: '5th' },
  '6': { color: '#FFE4C4', label: '6th' }
};

// Chart colors
export const chartColors = {
  blues: [
    brandColors.primary,
    brandColors.accent,
    brandColors.secondary,
    brandColors.dark,
    '#4b6cdc',
    '#8ba3e8',
    '#d4ddf5',
    brandColors.light,
    '#5470d6',
    '#7389e8',
  ]
};

// Helper functions
export const getDisciplineColor = (discipline: string): string => {
  const normalizedDiscipline = discipline.toLowerCase();
  return disciplineColorConfig[normalizedDiscipline as keyof typeof disciplineColorConfig]?.color || '#7389e8';
}; 